import LogoLight from '@assets/icons/logo/logo-name-big.svg';
import LogoDark from '@assets/icons/logo/logo-name-big-dark.svg';
import LogoLightSmall from '@assets/icons/logo/logo-small.svg';
import LogoDarkSmall from '@assets/icons/logo/logo-small-dark.svg';
import LogoVcfcSmall from '@assets/icons/logo/logo-vcfc-small.svg';
import LogoVcfc from '@assets/icons/logo/logo-vcfc.svg';

enum Palette {
  INSIGNIA = 'insignia',
  VCFC = 'vcfc',
  DEFAULT = '',
}

const COLOR_PALETTE = process.env.COLOR_PALETTE?.toLowerCase();

export class PaletteUtils {
  static isInsigniaPalette = !COLOR_PALETTE || COLOR_PALETTE === Palette.DEFAULT || COLOR_PALETTE === Palette.INSIGNIA;
  static isVcfcPalette = COLOR_PALETTE === Palette.VCFC;

  static spendingByCurrencyInsigniaColors = ['#d7c29a', '#322ea9'];
  static spendingByCurrencyVcfcColors = ['#374A61', '#d3c39f1a', '#d3c39f00'];
  static expenseCategoriesVcfcColors = ['#374A61', '#545E4D', '#CAB8A3', '#A6A6A6', '#6A8794', '#A9C8D9'];
  static mostUsedMerchantsVcfcColors = ['#374A61', '#545E4D', '#CAB8A3', '#A6A6A6', '#A9C8D9'];

  static getColor = <T, U>(insigniaColor: T, vcfcColor?: U) => {
    if (this.isInsigniaPalette) return insigniaColor;
    if (this.isVcfcPalette) return vcfcColor;
    return;
  };

  static getLogo = (isDark: boolean, isCollapsed: boolean) => {
    if (this.isInsigniaPalette) {
      if (!isDark) return isCollapsed ? <LogoLightSmall /> : <LogoLight />;
      else return isCollapsed ? <LogoDarkSmall /> : <LogoDark />;
    }
    if (this.isVcfcPalette) return isCollapsed ? <LogoVcfcSmall /> : <LogoVcfc />;
    return null;
  };
}
